export default __webpack_public_path__ + "static/media/General's Armguards of the Watchtowers.95b4a1ec.jpg";